import { EnumHelper } from './EnumHelper'
export class EmailType extends EnumHelper {
  static Unknown = -1
  static Confirmation = 0
  static PasswordReset = 1
  static PdfValidationFinished = 2
  static OrderPaymentComplete = 3
  static HotfolderCrashInfo = 4
  static ProductionTransferFailed = 5
  static CreditAccountBalancesAreNotEqual = 6
  static QueueJobFailed = 7
  static InvitationConfirmation = 8
  static OrganizationInvitation = 9
  static AutocompletionFailed = 10
  static BeckumReadingConfirmation = 11
  static AutocompleteDeletionInfo = 18
}
